import React, { useEffect, useState } from "react";
import Request from "../../components/Request";
import "./style.scss";
import NoRecordsFound from "../../components/NoRecordsFound";
import { getMyRequests } from "../../services";

const MyRequests = (props) => {
  const [requests, setRequests] = useState([]);

  useEffect(()=>{
    loadMyRequests();
  },[]);

  const loadMyRequests = () =>{
    getMyRequests().then((response) =>{
      setRequests(response.data);
    });
  }
  return (
    <React.Fragment>
      <div className="row my-4">
        {requests.length ? (
          requests.map((request, index) => (
            <Request
              reload={() => loadMyRequests()}
              key={index}
              request={request}
            />
          ))
        ) : (
          <NoRecordsFound message={"No Requests Found"} />
        )}
      </div>
    </React.Fragment>
  );
};

export default MyRequests;
